export default "__VITE_ASSET__hnTDJ_B3__"